const apiUrl = process.env.REACT_APP_API_URL;

export const GetJutgeCazaTests = async (id: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/caza/${id}/test`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los tests de caza:', error);
        return [];
    }
};
